// getCallCardLink is deliberately not re-exported: it returns a destination that may still be
// relative to the current page, and next resolves such an href against router.pathname — which
// on a dynamic route is the pattern, giving a link to a literal /archive/[page]. Only
// useCallCardLink returns something ready for an href. Import the builder from "./links"
// directly if you really need the unresolved value.
export { useCallCardLink } from "./links";
export * from "./router";
export { default as useQuickInfoClose } from "./quickInfo";
